import axios from "axios";
import ClientContext from "../../utils/client-context/ClientContext";
import { log as pilog } from "../../utils/Logging";
import { handleAPIFailure } from "../../utils/api-log-helper/APILogHelper";
import { RESOURCE_PROCESSOR_MAP } from "./RemoteResourceUtil";

var fetchResources = function fetchResources(resourcesToFetch, callback) {
  var log = pilog.getLogger("ResourceAPI fetchResources");
  var url = "".concat(process.env.REACT_APP_BASE_PLATFORM_URL).concat(process.env.REACT_APP_STAGE, "/public/resources");
  var params = {
    headers: {
      "x-api-key": ClientContext._apiKey
    },
    timeout: parseInt(process.env.REACT_APP_HTTP_POST_TIMEOUT)
  };
  axios.post(url, resourcesToFetch, params).then(function (response) {
    log.debug("Successfully retrieved ".concat(response.data.length, " resources"));
    var resourceResponseArray = [];
    response.data.map(function (platformResource) {
      try {
        var resource = resourcesToFetch.filter(function (r) {
          return r.resourceName === platformResource.resourceName;
        })[0]; //sometimes we may want to fetch "text" and but not parse to JSON e.g. if it's HTML

        var processorType = resource.processor ? resource.processor : resource.encoding;
        log.debug("".concat(processorType, " for ").concat(resource.resourceName));
        var processor = RESOURCE_PROCESSOR_MAP[processorType];
        resourceResponseArray.push(processor(platformResource));
      } catch (error) {
        log.warn("Failed to process ".concat(platformResource.resourceName, " %o"), error);
      }
    });
    log.debug("Successfully processed ".concat(resourceResponseArray.length, " resources"));
    callback(resourceResponseArray);
  }).catch(function (error) {
    handleAPIFailure(error);
    callback(null);
  });
};

export var fetchContentSkipPlatform = function fetchContentSkipPlatform(resourceBundleUrl, onContent, onFailure) {
  var log = pilog.getLogger("ResourceAPI fetchContentSkipPlatform");
  axios.get(resourceBundleUrl).then(function (response) {
    log.debug("Successfully retrieved ".concat(resourceBundleUrl));
    log.debug("response: ", response); //check to make sure there is data

    if (typeof onContent === "function") {
      onContent(response.data);
    }
  }).catch(function () {
    if (typeof onFailure === "function") {
      onFailure("File doesn't exist");
    }
  });
};
export var fetchPlatformResources = function fetchPlatformResources(options, successCallback, failureCallback) {
  var log = pilog.getLogger("ResourceAPI fetchPlatformResources");

  if (options.locale === null) {
    delete options.locale;
  }

  var resourceList = options.resourceList,
      _options$applicationN = options.applicationName,
      applicationName = _options$applicationN === void 0 ? ClientContext._appName : _options$applicationN,
      _options$locale = options.locale,
      locale = _options$locale === void 0 ? ClientContext._locale : _options$locale,
      _options$tenantName = options.tenantName,
      tenantName = _options$tenantName === void 0 ? ClientContext._tenantName : _options$tenantName,
      _options$groupName = options.groupName,
      groupName = _options$groupName === void 0 ? ClientContext._groupName : _options$groupName,
      _options$ignoreCache = options.ignoreCache,
      ignoreCache = _options$ignoreCache === void 0 ? false : _options$ignoreCache,
      _options$tenantGroupO = options.tenantGroupOnly,
      tenantGroupOnly = _options$tenantGroupO === void 0 ? false : _options$tenantGroupO;
  var resourceAPIRequests = [];
  resourceList.map(function (resource) {
    var resourceRequest = {
      tenantName: tenantName,
      groupName: groupName,
      locale: locale,
      resourceName: resource.name,
      applicationName: resource.applicationName ? resource.applicationName : applicationName,
      encoding: resource.encoding,
      processor: resource.processor,
      ignoreCache: resource.ignoreCache || ignoreCache,
      tenantGroupOnly: tenantGroupOnly
    };
    log.debug(resourceRequest);
    resourceAPIRequests.push(resourceRequest);
  });
  log.debug("".concat(resourceAPIRequests.length, " Resource API requests"));
  fetchResources(resourceAPIRequests, function (result) {
    if (result) {
      successCallback(result);
    } else {
      if (failureCallback) {
        failureCallback([], "Failed to find resources");
      } else {
        log.warn("Unable to load platform resources, defaults will be used");
        successCallback([]);
      }
    }
  });
};